import React, { useEffect } from 'react';
import { Col, Row, Form } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { useForm, Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
//helpers
import { verificateNullValue } from 'helpers';
// components
import Button from 'components/backoffice/buttonCustom';
import CustomInput from 'components/backoffice/customInput';
import DeleteModalCustom from 'components/backoffice/modals/DeleteModalCustom';
import SearchCountry from 'components/backoffice/customInput/SearchCountry';
import SearchLocality from 'components/backoffice/customInput/SearchLocality';
import SpinnerComponent from 'components/backoffice/SpinnerComponent';

const EditorialForm = ({
  isEditing,
  onSubmitForm,
  onDelete,
  openModalDelete,
  setOpenModalDelete,
  defaultValues,
  loading
}) => {
  const { t } = useTranslation(['backoffice']);

  const {
    formState: { errors },
    setValue,
    reset,
    control,
    handleSubmit,
  } = useForm();

  useEffect(() => {
    if (!isEditing)
      reset(defaultValues);
  }, [reset, defaultValues]);

  useEffect(() => {
    if (defaultValues) {
      setValue('nombre_fiscal', verificateNullValue(defaultValues?.nombre_fiscal));
      setValue('nombre_comercial', verificateNullValue(defaultValues?.nombre_comercial));
      setValue('cif', defaultValues?.cif);
      setValue('direccion', defaultValues?.direccion);
      setValue('telefono', defaultValues?.telefono);
      setValue('email', defaultValues?.email);
      setValue('pais', defaultValues?.pais);
      setValue('localidad', defaultValues?.localidad);
    }
  }, [defaultValues])

  return (
    <div className="mt-5">
      <Form onSubmit={handleSubmit(onSubmitForm)}>
        <Row className="mt-4">
          <Col sm={12} md={12} lg={4} className="mb-md-2 mb-lg-0">
            <Controller
              name="nombre_fiscal"
              control={control}
              rules={{
                required: {
                  value: true,
                  message: t('camporequerido'),
                },
              }}
              render={({ field: { onChange, value } }) => (
                <CustomInput
                  id="nombre_fiscal"
                  type="text"
                  label={t('nombrefiscal')}
                  placeholder={t('nombrefiscal')}
                  value={value}
                  onChange={(e) => onChange(e)}
                />
              )}
            />
            {errors?.nombre_fiscal && <small className="text-danger ">{errors.nombre_fiscal.message}</small>}
          </Col>
          <Col sm={12} md={12} lg={4} className="mt-4 mt-sm-0 mb-md-2 mb-lg-0">
            <Controller
              name="nombre_comercial"
              control={control}
              render={({ field: { onChange, value } }) => (
                <CustomInput
                  id="nombre_comercial"
                  type="text"
                  label={t('nombrecomercial')}
                  placeholder={t('nombrecomercial')}
                  value={value}
                  onChange={(e) => onChange(e)}
                />
              )}
            />
          </Col>
          <Col sm={12} md={12} lg={4} className="mt-4 mt-sm-0 mb-md-2 mb-lg-0">
            <Controller
              name="cif"
              control={control}
              render={({ field: { onChange, value } }) => (
                <CustomInput
                  id="cif"
                  type="text"
                  label='CIF'
                  placeholder='CIF'
                  value={value}
                  onChange={(e) => onChange(e)}
                />
              )}
            />
          </Col>
        </Row>
        <Row className="mt-4">
          <Col sm={12} md={12} lg={4} className="mb-md-2 mb-lg-0">
            <Controller
              name="direccion"
              control={control}
              render={({ field: { onChange, value } }) => (
                <CustomInput
                  id="direccion"
                  type="text"
                  label={t('direccion')}
                  placeholder={t('direccion')}
                  value={value}
                  onChange={(e) => onChange(e)}
                />
              )}
            />
          </Col>
          <Col sm={12} md={12} lg={4} className="mt-4 mt-sm-0 mb-md-2 mb-lg-0">
            <Controller
              name="telefono"
              control={control}
              rules={{
                required: {
                  value: true,
                  message: t('camporequerido'),
                },
                pattern: {
                  value: /^[0-9]+$/,
                  message: t('solonumeros'),
                },
                minLength: {
                  value: 6,
                  message: t('minimumLength'),
                },
                maxLength: {
                  value: 15,
                  message: t('maximumLength'),
                },
              }}
              render={({ field: { onChange, value } }) => (
                <CustomInput
                  id="telefono"
                  type="text"
                  label={t('telefono')}
                  placeholder={t('telefono')}
                  value={value}
                  onChange={(e) => onChange(e)}
                />
              )}
            />
            {errors?.telefono && <small className="text-danger">{errors.telefono.message}</small>}
          </Col>
          <Col sm={12} md={12} lg={4} className="mt-4 mt-sm-0 mb-md-2 mb-lg-0">
            <Controller
              name="email"
              control={control}
              rules={{
                required: {
                  value: true,
                  message: t('camporequerido'),
                },
                pattern: {
                  value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                  message: t('incorrectFormat'),
                },
              }}
              render={({ field: { onChange, value } }) => (
                <CustomInput
                  id="email"
                  type="text"
                  label={t('correoelectronico')}
                  placeholder={t('correoelectronico')}
                  value={value}
                  onChange={(e) => onChange(e)}
                />
              )}
            />
            {errors?.email && <small className="text-danger">{errors.email.message}</small>}
          </Col>
        </Row>
        <Row className="mt-4">
          <Col sm={12} md={12} lg={4} className="mb-md-2 mb-lg-0">
            <Controller
              name="pais"
              control={control}
              render={({ field: { onChange, value } }) => (
                <SearchCountry
                  filterBy="nombre"
                  placeholder={t('searchByName')}
                  onSelected={(item) => onChange(item)}
                  defaultCountry={value}
                />
              )}
            />
          </Col>
          <Col sm={12} md={12} lg={4} className="mt-4 mt-sm-0 mb-md-2 mb-lg-0">
            <Controller
              name="localidad"
              control={control}
              render={({ field: { onChange, value } }) => (
                <SearchLocality
                  filterBy="nombre"
                  placeholder={t('searchByName')}
                  onSelected={(item) => onChange(item)}
                  defaultLocality={value}
                />
              )}
            />
          </Col>
        </Row>
      </Form>
      <div className="my-4 d-flex justify-content-end gap-3">
        <Button color="primary" onClick={handleSubmit(onSubmitForm)} loading={loading}>
          {t('save')}
          <SpinnerComponent loading={loading} />
        </Button>
        {isEditing && (
          <Button color="secondary" onClick={() => setOpenModalDelete(true)} loading={loading}>
            {t('eliminar')}
          </Button>
        )}
      </div>
      <DeleteModalCustom
        openModal={openModalDelete}
        setOpenModal={setOpenModalDelete}
        handleDelete={onDelete}
        deleteTitle={t('deleteeditorial')}
        beforeTitle={t('editar', { title: defaultValues?.nombre_fiscal })}
      />
    </div>
  );
};

EditorialForm.propTypes = {
  onSubmitForm: PropTypes.func.isRequired,
  defaultValues: PropTypes.object,
  isEditing: PropTypes.bool.isRequired,
  openModalDelete: PropTypes.bool,
  setOpenModalDelete: PropTypes.func,
  onDelete: PropTypes.func,
  id: PropTypes.any,
  loading: PropTypes.bool,
};

export default EditorialForm;